import { HttpClient } from '#client/http/index'
import {
  ProgramListParams,
  ProgramWithTimetables,
  ProgramId,
  ProgramDetails,
  Timetable,
  TimetableId,
  ProgramTimetableDetails,
  ProgramSearchResponse,
  ProgramSearchCountParams,
  ProgramSearchCountResponse,
} from '#client/resources/index'
import { ApiResponse, PagerMeta } from '#client/resources/types'
import { depend } from '#client/utils/depend'
import snakecaseKeys from 'snakecase-keys'

export const list = depend(
  { transformParams: snakecaseKeys },
  async (
    { transformParams },
    { httpClient }: { httpClient: HttpClient },
    params: ProgramListParams,
  ) => {
    const { data, meta }: ApiResponse<ProgramWithTimetables[], PagerMeta> =
      await httpClient.get(`/user/programs`, {
        params: transformParams({
          ...params,
          showFullReservations: params.showFullReservations ? 1 : 0,
          isOnline: params.isOnline ? 1 : 0,
        }),
      })
    return { data, meta }
  },
)

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: ProgramId,
) => {
  const { data }: ApiResponse<ProgramDetails> = await httpClient.get(
    `/user/programs/${id}`,
  )
  return data
}

export const listTimetables = async (
  { httpClient }: { httpClient: HttpClient },
  id: ProgramId,
) => {
  const { data }: ApiResponse<Timetable[]> = await httpClient.get(
    `/user/programs/${id}/timetables`,
  )
  return data
}

export const getTimetable = async (
  { httpClient }: { httpClient: HttpClient },
  id: ProgramId,
  timetableId: TimetableId,
) => {
  const { data }: ApiResponse<ProgramTimetableDetails> = await httpClient.get(
    `/user/programs/${id}/timetables/${timetableId}`,
  )
  return data
}

export const search = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<ProgramSearchResponse> = await httpClient.get(
    '/user/programs/search',
  )
  return data
}

export const searchCount = async (
  { httpClient }: { httpClient: HttpClient },
  params: ProgramSearchCountParams,
) => {
  const { data }: ApiResponse<ProgramSearchCountResponse> =
    await httpClient.get('/user/programs/search/count', {
      params: snakecaseKeys({
        ...params,
        showFullReservations: params.showFullReservations ? 1 : 0,
      }),
    })
  return data
}
